export function getApiGroups(introspectionResult) {
    //lazily create a map of apiGroup -> types/field names
    const types = introspectionResult["__schema"]["types"]
    const apiGroupsMap = new Map()
    for (let typesKey in types) {
        if (typesKey !== "Query" || typesKey !== "Mutation" || typesKey !== "Subscription") {
            const type = types[typesKey]
            const appliedDirectives = type.appliedDirectives
            const apiGroupsList = appliedDirectives.filter(directive => directive.name==="apiGroup")
            for (let apiGroupsKey in apiGroupsList) {
                const apiGroup = apiGroupsList[apiGroupsKey]["args"][0]["value"]
                if (apiGroupsMap.has(apiGroup)) {
                    apiGroupsMap.set(apiGroup, [...apiGroupsMap.get(apiGroup), type.name])
                } else {
                    apiGroupsMap.set(apiGroup, [type.name])
                }
            }
            //now add all the fields as well
            const fields = type["fields"]
            addFieldsFromApiGroup(apiGroupsMap, type, fields)
        } else {
            //pull out the top level fields
            const type = types[typesKey]
            const fields = type.fields
            addFieldsFromApiGroup(apiGroupsMap, type, fields)
        }
    }

    function addFieldsFromApiGroup(apiGroupsMap, type, fields) {
        for (let fieldsKey in fields) {
            const field = fields[fieldsKey]
            const appliedDirectives = field.appliedDirectives
            const apiGroupsList = appliedDirectives.filter(directive => directive.name==="apiGroup")
            for (let apiGroupsKey in apiGroupsList) {
                const apiGroup = apiGroupsList[apiGroupsKey]["args"][0]["value"]
                const fieldName = type.name+"."+field.name
                if (apiGroupsMap.has(apiGroup)) {
                    apiGroupsMap.set(apiGroup, [...apiGroupsMap.get(apiGroup), fieldName])
                } else {
                    apiGroupsMap.set(apiGroup, [fieldName])
                }
            }
        }
    }

    return apiGroupsMap;
}

export function filterSchemaByApiGroup(schema, apiGroupMap, service) {
    const typesFieldsToFilter = apiGroupMap.get(service)
    const queryFields = schema.getQueryType().getFields()

    const filteredQueryFields = Object.keys(queryFields)
        .filter(k => typesFieldsToFilter.includes("Query."+k))
        .reduce((acc, key) => {
            acc[key] = queryFields[key];
            return acc
        }, {})

    const mutationFields = schema.getMutationType().getFields()
    const filteredMutationFields = Object.keys(mutationFields)
        .filter(k => typesFieldsToFilter.includes("Mutation."+k))
        .reduce((acc, key) => {
            acc[key] = mutationFields[key];
            return acc
        }, {})

    const subscriptionFields = schema.getSubscriptionType().getFields()
    const filteredSubscriptionFields = Object.keys(subscriptionFields)
        .filter(k => typesFieldsToFilter.includes("Subscription."+k))
        .reduce((acc, key) => {
            acc[key] = subscriptionFields[key];
            return acc
        }, {})

    const types = schema.getTypeMap()
    const filteredTypes = Object.keys(types)
        .filter(k => typesFieldsToFilter.includes(k))
        .reduce((acc, key) => {
            acc[key] = types[key];
            return acc
        }, {})

    function addAllReachableTypes(types, filteredTypes) {
        const addedTypes = new Set()
        for (let typeName in filteredTypes) {
            const type = filteredTypes[typeName]
            const fields = type.getFields()
            for (let fieldName in fields) {
                const field = fields[fieldName]
                const fieldTypeName = field.type.name
                if (fieldTypeName !== undefined && !(fieldTypeName in filteredTypes)) {
                    addedTypes.add(fieldTypeName)
                }
            }

            // const interfaces = type.getInterfaces()
            // for (let i = 0; i < interfaces.length; i++) {
            //     const interfaceType = interfaces[i]
            //
            // }
        }

        addedTypes.forEach(typeName => {
            filteredTypes[typeName] = types[typeName]
        })
    }

    addAllReachableTypes(types, filteredTypes)

    if (Object.keys(filteredQueryFields).length > 0) {
        filteredTypes.Query= types.Query
    }

    if (Object.keys(filteredMutationFields).length > 0) {
        filteredTypes.Mutation = types.Mutation
    }

    if (Object.keys(filteredSubscriptionFields).length > 0) {
        filteredTypes.Subscription = types.Subscription
    }

    schema.getQueryType()._fields = filteredQueryFields;
    schema.getMutationType()._fields = filteredMutationFields;
    schema.getSubscriptionType()._fields = filteredSubscriptionFields;

    schema._typeMap = filteredTypes;
    return schema
}